import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import { CSVLink } from 'react-csv';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { q50, q25, q75 } from './utils/data-compare';

export default class ActivityAggregationTable extends PureComponent {
  reshapeData = data => {
    let outData = [];
    let tempObj;
    Object.entries(data).forEach(([item_id, item_res]) => {
      let time = q50(Object.values(item_res.time)) / 60.0;
      tempObj = {
        item_id,
        mean_accuracy:
          (_.sum(Object.values(item_res.score)) /
            (Object.values(item_res.score).length *
              q50(Object.values(item_res.max_score)))) *
          100,
        median_accuracy:
          (q50(Object.values(item_res.score)) / q50(Object.values(item_res.max_score))) *
          100,
        q1_accuracy:
          (q25(Object.values(item_res.score)) / q50(Object.values(item_res.max_score))) *
          100,
        q3_accuracy:
          (q75(Object.values(item_res.score)) / q50(Object.values(item_res.max_score))) *
          100,
        median_time: time,
        q1_time: q75(Object.values(item_res.time)) / 60.0,
        q3_time: q25(Object.values(item_res.time)) / 60.0,
        time_per_widget: time / item_res.num_widgets,
        mean_total_attempts:
          _.sum(Object.values(item_res.avg_attempts)) /
          Object.values(item_res.avg_attempts).length,
        num_widgets: item_res.num_widgets,
        num_data_points: Object.values(item_res.score).length,
      };
      outData.push(tempObj);
    });
    return outData;
  };

  render() {
    const { data } = this.props;
    if (!data) {
      console.log('outData NOTHING 1');
      return <div>No Data</div>;
    }
    let processedData = this.reshapeData(data);

    return (
      <div>
        <CSVLink data={processedData} filename={'Activity_data_'}>
          Download Data
        </CSVLink>
        {processedData && (
          <ReactTable
            data={processedData}
            pageSize={20}
            pageSizeOptions={[20, 30, 50, 100, 200, 500]}
            // resolveData = {data => this.reshapeData(data)}
            columns={[
              {
                Header: 'Activity',
                columns: [
                  {
                    Header: 'Index',
                    id: 'row',
                    maxWidth: 50,
                    filterable: false,
                    Cell: row => {
                      return <div>{row.index + 1}</div>;
                    },
                  },
                  {
                    Header: 'Item Reference',
                    id: 'item_id',
                    maxWidth: 200,
                    accessor: d => (
                      <Link
                        to={'https://author.learnosity.com/login' + d._id}
                        target="_blank"
                      >
                        {d.item_id}
                      </Link>
                    ),
                  },
                  {
                    Header: '#Widgets',
                    accessor: 'num_widgets',
                    maxWidth: 80,
                  },
                  {
                    Header: 'Accuracy: Mean',
                    id: 'mean_accuracy',
                    maxWidth: 80,
                    accessor: d => d.mean_accuracy.toFixed(2),
                  },
                  {
                    Header: 'Accuracy: Bottom 25%(%) ',
                    id: 'q1_accuracy',
                    maxWidth: 80,
                    accessor: d => d.q1_accuracy.toFixed(2),
                  },
                  {
                    Header: 'Accuracy: Median(%) ',
                    id: 'median_accuracy',
                    maxWidth: 80,
                    accessor: d => d.median_accuracy.toFixed(2),
                  },
                  {
                    Header: 'Accuracy: Top 25%(%) ',
                    id: 'q3_accuracy',
                    maxWidth: 80,
                    accessor: d => d.q3_accuracy.toFixed(2),
                  },
                  {
                    Header: 'Time taken: Bottom 25%(%) ',
                    id: 'q1_time',
                    maxWidth: 80,
                    accessor: d => d.q1_time.toFixed(2),
                  },
                  {
                    Header: 'Time taken: Median(%) ',
                    id: 'median_time',
                    maxWidth: 80,
                    accessor: d => d.median_time.toFixed(2),
                  },
                  {
                    Header: 'Time taken: Top 25% ',
                    id: 'q3_time',
                    maxWidth: 80,
                    accessor: d => d.q3_time.toFixed(2),
                  },
                  {
                    Header: '#Attempts (Median)',
                    id: 'mean_total_attempts',
                    maxWidth: 80,
                    accessor: d => d.mean_total_attempts.toFixed(2),
                  },
                  {
                    Header: 'Time Per Widget',
                    id: 'time_per_widget',
                    maxWidth: 80,
                    accessor: d => d.time_per_widget.toFixed(2),
                  },
                  {
                    Header: 'Time Per Widget',
                    id: 'time_per_widget',
                    maxWidth: 80,
                    accessor: d => d.time_per_widget.toFixed(2),
                  },
                  {
                    Header: '#Data Points',
                    accessor: 'num_data_points',
                    maxWidth: 80,
                  },
                ],
              },
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    );
  }
}
